<template>
  <v-container id="order-list" fluid tag="section">
    <div class="md-layout">
      <v-tabs color="primary" style="background-color: #FFFFFF; padding: 5px 0px 10px 5px;">
        <v-tab v-for="(tab, i) in tabs" :key="i" :to="tab.to">{{ tab.text }}</v-tab>
      </v-tabs>
      <contact-order-filter-form :filter-form="filterForm" />
      <div class="text-sm-right mb-4 mt-4">
        <!-- <v-btn v-if="checkAuthorization('order_create') && checkConditionT4NT5(_.get(dataContact, 'contactStatus.type', '')) && !checkIncludesT4NT5(_.get(dataContact, 'contactStatus.type', ''))" color="primary" dark class="mb-2" @click="clickAddOrder">
          <v-icon>mdi-plus</v-icon>Tạo đơn hàng mới
        </v-btn> -->
        <v-btn v-if="checkAuthorization('order_create') && checkNotIncludesM(dataContact.contactStatus.type)" color="primary" dark class="mb-2" @click="clickAddOrder">
          <v-icon>mdi-plus</v-icon>Tạo đơn hàng mới
        </v-btn>
      </div>
      <contact-order-table :orders="orders" :totalPrice="totalPrice"/>
      <common-no-result v-if="!loading && orders.length === 0" />
      <!-- Paginate -->
      <div class="pb-0 d-flex justify-end px-3 mt-5">
        <div class="text-right mb-1 mt-2">
          {{ showContactsIndex() }}
          <v-btn small class="pagination-btn-left" @click="currentPage--; idPaging = paging.previousId"
            :disabled="currentPage == 1">
            <v-icon>mdi-menu-left</v-icon>
          </v-btn>
          <v-btn small class="pagination-btn-right" @click="currentPage++; idPaging = paging.nextId"
            :disabled="!paging.nextId"
          >
            <v-icon>mdi-menu-right</v-icon>
          </v-btn>
        </div>
        <!-- <div style="width: 35px">
          <v-text-field class="pt-0" v-model="pendingPage" min="1" step="1" type="number" @input="applyPendingPage()">
          </v-text-field>
        </div> -->
      </div>
      <!-- <v-row>
        <v-col cols="12" sm="6" />
        <v-col cols="12" sm="6">
          <v-pagination
            v-if="totalItem > limit"
            v-model="currentPage"
            :length="getTotalItem(totalItem)"
            class="justify-sm-end"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
          />
        </v-col>
      </v-row> -->
    </div>
  </v-container>
</template>

<script>
import ContactOrderFilterForm from './components/ContactOrderFilterForm';
import ContactOrderTable from './components/ContactOrderTable';

import RepositoryFactory from '../../repositories/RepositoryFactory';
const OrderRepository = RepositoryFactory.get('order');
const ContactRepository = RepositoryFactory.get('contact');
import { contactDetailTabMenu } from '../../helpers/constants';

export default {
  components: {
    ContactOrderFilterForm,
    ContactOrderTable
  },
  data() {
    return {
      tabs: [],
      filterForm: {
        code: ''
      },
      currentPage: 1,
      limit: 50,
      totalItem: 0,
      orders: [],
      loading: true,
      totalPrice: 0,
      dataContact: {},
      backward: false,
      paging: {},
      idPaging: null,
    };
  },
  async created() {
    this.getOrderList();
    const contactId = _.get(this, '$route.params.id', '');
    this.tabs = contactDetailTabMenu(contactId);
    this.getContactDetail()
    Bus.$on('order-list-filter', filterForm => {
      this.filterForm = filterForm;
      this.currentPage = 1;
      this.getOrderList();
    });
  },
  beforeDestroy() {
    Bus.$off('order-list-filter');
  },
  methods: {
    clickAddOrder() {
      let self = this
      if (this.dataContact.mainId) {
        this.$swal({
          title: 'Số điện thoại đã được gộp vào contact ' + self.dataContact.phoneRelated[0] + '.<br>Vui lòng thực hiện các thao tác tại contact chính.',
          confirmButtonText: 'Xem contact chính',
          showCancelButton: true,
          cancelButtonText: 'Quay lại'
        }).then((res) => {
          if (res.value) {
            let routeData = self.$router.resolve({
              name: 'ContactDetail',
              params: {
                id: self.dataContact.mainId || 0
              }
            })
            window.open(routeData.href, '_blank')
          }
        })
      } else {
        const id = _.get(this, '$route.params.id', '')
        //   if((this.$store.state.module.typeId && this.$store.state.module.typeId == 2)) {
        //     this.$router.push({name: 'OrderTutorCreate', params: { id: id }});    
        //   }else {
        //     this.$router.push({name: 'OrderCreate', params: { id: id }});
        // }
        this.$router.push({name: 'OrderCreate', params: { id: id }});
      }
    },
    async getOrderList() {
      const contactId = _.get(this, '$route.params.id', '');
      const params = {
        limit: this.limit,
        page: this.currentPage - 1,
        code: this.filterForm.code,
        contactId,
        backward: this.backward,
        id: this.idPaging || "",
        fromQuickView: 1,
      };
      this.loading = true;
      const loader = this.$loading.show();
      const response = await OrderRepository.list(params);
      loader.hide();
      this.totalPrice = 0;
      this.loading = false;
      if (response.success) {
        this.orders = this.mappingOrderList(_.get(response, 'data.data', []));
        this.paging = {
          nextId: _.get(response, 'data.paging.nextId', null),
          previousId: _.get(response, 'data.paging.previousId', null),
        };
        this.totalItem = _.get(response, 'data.totalItem', 0);
        this.totalPrice = _.get(response, 'data.totalPrice', 0);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
        this.orders = [];
        this.totalItem = 0;
      }
    },
    mappingOrderList(orders) {
      return orders.map(order => {
        const orderTemp = order;
        let productComboList = [];
        _.get(orderTemp, 'combos', []).forEach(dataCombo => {
          productComboList.push({
            name: dataCombo.name,
            quantity: dataCombo.quantity,
            childName: dataCombo.childName,
            courseProductNames: dataCombo.courseProductNames
          })
        });
        _.get(orderTemp, 'products', []).forEach(dataProduct => {
          productComboList.push({
            name: dataProduct.name,
            quantity: dataProduct.quantity,
            childName: dataProduct.childName,
            courseProductNames: dataProduct.courseProductNames
          })
        });

        orderTemp.rowspan = productComboList.length === 0 ? 1 : productComboList.length;
        orderTemp.productComboList = productComboList;
        return orderTemp;
      });
    },
    async getContactDetail() {
      const loading = this.$loading.show();
      const respond = await ContactRepository.detail(this.$route.params.id);
      loading.hide();
      if (_.get(respond, 'success', false) && _.get(respond, 'data', null)) {
        this.dataContact = _.get(respond, 'data', {});
        if(!this.dataContact.contactStatus) {
          this.dataContact.contactStatus = {}
        }
      }
    },
    showContactsIndex() {
      if(this.orders.length > 0) {
        let maxIndex = parseInt(this.currentPage)*parseInt(this.limit)
        return (maxIndex - parseInt(this.limit) + 1) + ' - ' + maxIndex
      }else {
        return ('0 - 0')
      }
    },
  },
  watch: {
    currentPage: {
      handler(newVal, oldVal) {
        this.backward = newVal < oldVal;
        this.getOrderList();
      }
    },
    limit: {
      handler() {
        if (this.currentPage === 1) {
          this.getOrderList();
        } else {
          this.currentPage = 1;
        }
      }
    }
  }
};
</script>
